import { nestedEntitiesJoinCharacter } from "../entity/types/base.js";
import "fast-deep-equal/es6";
import "immer";
import "redux";
import "typesafe-actions";
import "../entity/epics.js";
import "normalizr";
import "rxjs";
import "../entity/EntityProvider.js";
import "react";
function getFlattenedNestedFieldValuesDenormalized(field, items) {
  const splitted = field.split(nestedEntitiesJoinCharacter);
  const result = items ? items.map((item) => {
    let value = item;
    if (value) {
      for (let index = 0; index < splitted.length; index++) {
        const fieldPart = splitted[index];
        if (fieldPart?.length) {
          if (Array.isArray(value)) {
            value = value?.map((i) => i?.[fieldPart]);
          } else {
            value = value?.[fieldPart];
          }
        }
      }
    }
    return value;
  }).flatMap((a) => a) : [];
  return result;
}
function getSubscriptionKey(entity, trigger, args) {
  return `${entity}_${trigger}${args ? `_${JSON.stringify(args)}` : ""}`;
}
export {
  getFlattenedNestedFieldValuesDenormalized,
  getSubscriptionKey
};
//# sourceMappingURL=utils.js.map
